<template>
  <el-drawer
    title="导入导出记录"
    :visible.sync="drawer"
    destroy-on-close
    :wrapperClosable="false"
    size="90%"
    :custom-class="sidebarIsOpen ? 'width210' : 'width54'"
    :before-close="handleClose"
  >
    <el-card style="padding: 0 12px">
      <div class="pb-27 text_headr" style="display: flex; align-items: center; justify-content: space-between">
        <el-button type="primary" :loading="loadingN" size="small" @click="addData">刷新</el-button>
        <span>*文件生成后有效期为1天，1天内可下载。仅为您保留7天内的文件处理记录</span>
      </div>
      <el-table v-loading="loading" ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="文件名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.fileName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="文件类型" align="center">
          <template slot-scope="scope">{{ scope.row.fileTypeNameStr || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.excelOperationType == 1 ? '导入' : '导出' }}
          </template>
        </el-table-column>
        <!-- cutTime(scope.row.houseDevelopersEndDate, ' ') -->
        <el-table-column label="操作时间" align="center">
          <template slot-scope="scope">{{ scope.row.createTime }}</template>
        </el-table-column>
        <el-table-column label="处理进度" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.row.schedule }} -->
            <template>
              <el-progress :percentage="scope.row.schedule" :show-text="false"></el-progress>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-link :class="{ disabled: !Number(scope.row.realAmount || 0) }" type="primary" @click="viewReceipt(scope.row)">收据</el-link> -->
            <template v-if="scope.row.excelState == 1 || scope.row.excelState == 4 || scope.row.excelState == 2">
              {{ '-' }}
            </template>
            <el-button
              :class="{ disabled: scope.row.isDownloadUrlUse == 0 }"
              v-else
              :disabled="disabled"
              type="default"
              :loading="scope.row.isLoading"
              size="small"
              @click="invoicing(scope.row.downloadUrl, scope.row.isDownloadUrlUse, scope.row.fileName.slice(0, scope.row.fileName.length - 5), scope.$index)"
            >
              下载
            </el-button>
            <!-- <el-link
              v-else
              :class="{ disabled: scope.row.excelState == 6 }"
              type="primary"
              @click="invoicing(scope.row.downloadUrl, scope.row.excelState, dictType('exportState', scope.row.fileTypeName))"
            >

            </el-link> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 15, 25, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
  </el-drawer>
</template>

<script>
import { excelRecordPage, excelRecordCount } from '@/api/finance'
import axios from 'axios'
import { baseURL } from '@/api/getFile'
import { downloadFiles } from '@/utils/tool'
import { getToken } from '@/utils/auth'
export default {
  inject: ['indexThis'],
  data() {
    return {
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
      isLoading: false,
      loadingN: false,
      timer: null,
      disabled: false,
    }
  },
  computed: {
    drawer() {
      return this.$store.state.tagsView.recordDraw
    },
  },
  // created() {
  //   this.init()
  //   if (this.timer) return
  //   this.timer = setInterval(() => {
  //     this.init()
  //   }, 20_000)
  // },
  watch: {
    drawer(newVal, oldVal) {
      if (!newVal) {
        clearInterval(this.timer)
      } else {
        this.init()
        this.timer = setInterval(() => {
          this.init()
        }, 10000)
      }
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    handleClose() {
      this.$store.dispatch('tagsView/uprecordDraw', false)
    },

    init() {
      this.developerPayItemPage()
    },
    addData() {
      this.loadingN = true

      this.developerPayItemPage()
    },
    async developerPayItemPage() {
      const { data } = await excelRecordPage({ ...this.page })
      data.forEach(element => {
        element.isLoading = false
        if (element.excelState == 1 || element.excelState == 4) {
          element.schedule = 50
        } else if (element.excelState == 2 || element.excelState == 3 || element.excelState == 5) {
          element.schedule = 100
        } else if (element.excelState == 6) {
          element.schedule = 0
        }
      })
      this.tableData = data
      this.loadingN = false
      const { data: total } = await excelRecordCount({})
      this.total = Number(total)
      this.$forceUpdate()
    },
    currentChange() {
      this.developerPayItemPage()
    },
    invoicing(downloadUrl, isDownloadUrlUse, exportState, index) {
      if (isDownloadUrlUse == 0) return false
      this.tableData[index].isLoading = true

      axios({
        url: `${baseURL}common/getFile?filePath=${downloadUrl}&token=${getToken()}`,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
        downloadFiles(res, exportState, 'xlsx')
        this.tableData[index].isLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  ::v-deep .el-card__body {
    padding: 24px !important;
  }
}
@media (max-width: 1350px) {
  .el-col-lg-12 {
    width: 65% !important;
  }
}
@media (min-width: 1350px) and (max-width: 1411px) {
  .el-col-lg-12 {
    width: 50% !important;
  }
}
@media (min-width: 1412px) and (max-width: 1555px) {
  .el-col-lg-12 {
    width: 45% !important;
  }
}
@media (min-width: 1556px) and (max-width: 1791px) {
  .el-col-lg-12 {
    width: 40% !important;
  }
}

@media (min-width: 1556px) and (max-width: 1660px) {
  .el-col-lg-12 {
    width: 40% !important;
  }
}
@media (min-width: 1661px) {
  .el-col-lg-12 {
    width: 37% !important;
  }
}
.text_headr {
  color: #9e9e9e;
  font-size: 14px;
}
.disabled {
  background: #e7e7e7 !important;
  color: #a3a6ad !important;
}
</style>
